import { render, staticRenderFns } from "./alt-select.vue?vue&type=template&id=6175825d&"
import script from "./alt-select.ts?vue&type=script&lang=ts&"
export * from "./alt-select.ts?vue&type=script&lang=ts&"
import style0 from "./alt-select.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports